import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { VolunteerFormFields } from "@/pages/system-settings/volunteers/components/VolunteerFormFields";
import { useVolunteerCreation } from "@/pages/system-settings/volunteers/components/create-volunteer/hooks/useVolunteerCreation";
import { useTranslation } from "@/translations";

interface Props {
  onClose: () => void;
}

export function VolunteerCreationDialog({ onClose }: Props) {
  const { t } = useTranslation();
  const { formik, dropdownOptions } = useVolunteerCreation(onClose);

  return (
    <FormDialog
      title={t("volunteers.create.dialogTitle")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
    >
      <VolunteerFormFields formik={formik} dropdownOptions={dropdownOptions} />
    </FormDialog>
  );
}
